import React from 'react';
import styled from '@emotion/styled/macro';
import cx from 'classnames';

const Text = styled.div`
  font-size: 15px;
  position: relative;
  padding-left: 8px;
  color: #353d45;
  display: flex;
  align-items: center;

  ::before {
    content: ' ';
    position: absolute;
    top: 3px;
    left: 0;
    width: 2px;
    height: 16px;
    background: #26abe3;
  }
`;

const Wrapper = styled.div`
  height: 40px;
  border-bottom: 1px solid #e9eced;
  font-size: 15px;
`;

export default function SubHeader(props: {
  children?: React.ReactNode;
  rightSide?: React.ReactNode;
  className?: string;
}) {
  const {children, className, rightSide} = props;
  return (
    <Wrapper
      className={cx(
        'h-10 text-base my-5',
        'flex items-center justify-between',
        'border-bottom border-[#e9eced]',
        className,
      )}
    >
      <Text>{children}</Text>
      {rightSide ? rightSide : <></>}
    </Wrapper>
  );
}
